import { CurrencyType } from "../../Plans";

export const EVENT_NAME_MAX_LENGTH = 50;
export const EVENT_DESCRIPTION_MAX_LENGTH = 500;
export const EVENT_LOCATION_MAX_LENGTH = 300;
export const TICKET_NAME_MAX_LENGTH = 50;
export const TICKET_DESCRIPTION_MAX_LENGTH = 200;
export const SALE_DATE_MIN_DURATION_MINUTES = 5;

export const CURRENCIES: CurrencyType[] = ["USD", "EUR", "CHF"];

export const DEFAULT_EVENT_VALUES = {
  event_name: "",
  event_description: "",
  location: "",
  active: true,
  event_image_url: "",
} as const;

export const DEFAULT_TICKET_VALUES = {
  name: "",
  description: "",
  price: 0,
  currency: "USD" as CurrencyType,
  quantity_total: undefined as number | undefined,
  min_per_order: 1,
  max_per_order: 2,
  show_remaining_tickets: true,
  sale_start_date: "",
  sale_end_date: "",
  group_identification: "",
} as const;

export const T_PREFIX = "components.eventPayments" as const;
